// extracted by mini-css-extract-plugin
module.exports = {"shadow":"styles_shadow__chSX6","idGrid":"styles_idGrid__2lCtn","gridContainer":"styles_gridContainer__31GKI"};